export enum CoursesTypes {
  GET_COURSE_REQUEST = '@course/GET_COURSE_REQUEST',
  GET_COURSE_SUCCESS = '@course/GET_COURSE_SUCCESS',
  GET_COURSE_FAILURE = '@course/GET_COURSE_FAILURE',
  GET_START_COURSE_REQUEST = '@course/GET_START_COURSE_REQUEST',
  GET_START_COURSE_SUCCESS = '@course/GET_START_COURSE_SUCCESS',
  GET_START_COURSE_FAILURE = '@course/GET_START_COURSE_FAILURE',
  MARK_AS_DONE_REQUEST = '@course/MARK_AS_DONE_REQUEST',
  MARK_AS_DONE_SUCCESS = '@course/MARK_AS_DONE_SUCCESS',
  MARK_AS_DONE_FAILURE = '@course/MARK_AS_DONE_FAILURE',
  GET_USER_PROGRESS_REQUEST = '@course/GET_USER_PROGRESS_REQUEST',
  GET_USER_PROGRESS_SUCCESS = '@course/GET_USER_PROGRESS_SUCCESS',
  GET_USER_PROGRESS_FAILURE = '@course/GET_USER_PROGRESS_FAILURE',
  PROGRESS_REQUEST = '@course/PROGRESS_REQUEST',
  PROGRESS_SUCCESS = '@course/PROGRESS_SUCCESS',
  PROGRESS_FAILURE = '@course/PROGRESS_FAILURE',
}

export interface ContactClassProgressionTypes {
  concluded: boolean;
}

export interface LessonTypes {
  last_class: {
    created_at: number;
    id: number;
    nome: string;
    status_id: boolean;
    updated_at: string;
    order: number;
    topic_id: number;
    url_video: string;
    progression: number;
    total_aula: number;
  };
  ordem: number;
  nome: string;
  url_video: string;
  contact_class_progression: Array<ContactClassProgressionTypes>;
  progression: number;
  total_aula: number;
  id: number;
  free: boolean;
}

export interface TopicTypes {
  course_id: number;
  created_at: number;
  id: string;
  name: string;
  status: boolean;
  updated_at: string;
  order: number;
  lessons: Array<LessonTypes>;
  completed_lessons_count: number;
}

export interface CourseTypes {
  id: number;
  description: string;
  created_at: string;
  name: string;
  status: boolean;
  updated_at: string;
  topics: Array<TopicTypes>;
  last_class: {
    progression: number;
    total_aula: number;
    last_class: {
      nome: string;
      url_video: string;
    };
  };
  lessons: Array<LessonTypes>;
  steps_completed: Array<any>;
}

export interface RequestState {
  get_course: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  mark_as_done: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  start_course: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
}

export interface CourseState {
  course: CourseTypes;
  readonly request: RequestState;
}
